import { TablePagerSkeletonLoader } from '@/components/BaseTable/TablePagerSkeletonLoader';
import { Skeleton } from '@/components/ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import type { TableVariant } from '@/components/ui/table';
import { cn } from '@/lib/utils';

const DEFAULT_COLUMN_WIDTHS = [10, 500, 200, 10, 10];

interface SkeletonLoaderProps {
  variant?: TableVariant;
  columns?: number;
}

export function SkeletonLoader({ variant = 'default', columns }: SkeletonLoaderProps) {
  const isGhost = variant === 'ghost';
  const columnCount = columns ?? DEFAULT_COLUMN_WIDTHS.length;

  return (
    <div className="space-y-4">
      {!isGhost && (
        <div className="flex items-center justify-between">
          <div className="flex flex-1 items-center space-x-2">
            <Skeleton className="h-8 w-56 lg:w-80" />
            <Skeleton className="h-8 w-[100px]" />
            <Skeleton className="h-8 w-[100px]" />
          </div>
          <Skeleton className="h-8 w-[100px]" />
        </div>
      )}
      <div className={cn('rounded-md', !isGhost && 'border')}>
        <Table variant={variant}>
          <TableHeader>
            <TableRow>
              {Array.from({ length: columnCount }, (_, i) => (
                <TableHead
                  key={i}
                  style={
                    !isGhost && i < DEFAULT_COLUMN_WIDTHS.length
                      ? { width: `${DEFAULT_COLUMN_WIDTHS[i]}px` }
                      : undefined
                  }
                >
                  <Skeleton className="h-4 w-full" />
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: 10 }, (_, rowIndex) => (
              <TableRow key={rowIndex}>
                {Array.from({ length: columnCount }, (_, cellIndex) => (
                  <TableCell key={cellIndex} className={!isGhost ? 'p-2' : undefined}>
                    <Skeleton className="h-4 w-full" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <TablePagerSkeletonLoader />
    </div>
  );
}
